import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import Snackbar from 'material-ui/Snackbar'
import ContactText from './ContactText'

class ContactForm extends Component {
  constructor (props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      subject: props.activeRole || '',
      message: '',
      snackbarOpen: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const { activeRole } = nextProps
    document.getElementById('subject').value = activeRole
    this.setState({ subject: activeRole })
  }

  handleChange (event) {
    this.setState({ [event.target.id]: event.target.value})
  }

  handleSubmit (event) {
    event.preventDefault();
    const payload = this.state
    const { formName } = this.props

    window.analytics.identify({
      firstName: payload.firstName,
      lastName: payload.lastName,
      email: payload.email,
      subject: payload.subject,
      message: payload.message
    }, {
      "MailChimp": {
        "listId": "1602018768"
      }
    })

    if (formName === "Contact") {
      window.analytics.track('Contact Form Submitted',
        payload,
        {
          integrations: {
            'Webhooks': false
          }
        },
        ()=> {
        this.setState({ snackbarOpen: true })
      })
    } else {
      window.analytics.track('Donate Form Submitted',
        payload,
        {
          integrations: {
            'Webhooks': false
          }
        },
        () => {
        this.setState({ snackbarOpen: true })
      })
    }
  }

  render () {
    const { formName, scrollElement } = this.props
    const { snackbarOpen } = this.state

    return (
      <div className="contact-form">
        <ContactText formName={ formName } />
        { scrollElement }
        <form className="forms">
          <h2>{ formName } Us</h2>
          <div className="form-names">
            <div className="form-cell">
              <input
                id="firstName"
                onChange={this.handleChange}
                placeholder="First Name" 
                type="text"
                />
            </div>
            <div className="form-cell">
              <input
                id="lastName"
                onChange={this.handleChange}
                placeholder="Last Name"
                type="text"
              />
            </div>
          </div>
          <div className="form-cell">
            <input
              id="email"
              onChange={this.handleChange}
              placeholder="Email Address"
              type="text"
            />
          </div>
          <div className="form-cell">
            <input
              id="subject"
              onChange={this.handleChange}
              placeholder="Subject"
              type="text"
            />
          </div>
          <div className="form-cell message-cell">
            <input
              id="message"
              onChange={this.handleChange}
              placeholder="Message"
              type="text"
            />          
          </div>
        </form>
        <div className='submit-div'>
          <RaisedButton
            backgroundColor="#767576"
            className="submit-button"
            onClick={this.handleSubmit}
            label="Send Message"
            labelColor="white"
            rippleStyle={{ backgroundColor: "#BABD3D", color: "#BABD3D"}}
          />
        </div>
        <Snackbar
          autoHideDuration={4000}
          message="Thanks, we'll be in touch soon!"
          onRequestClose={()=> this.setState({snackbarOpen: false})}
          open={snackbarOpen}
          bodyStyle={{ backgroundColor: "#aa82ff"}}
          contentStyle={{ backgroundColor: "#aa82ff"}}
        />
      </div>
    )  
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js